export const IMAGE = {
  top: "https://navismithapis-cdn.com/img/menu_home.svg",
  help: "https://navismithapis-cdn.com/img/help.svg",
};
